/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../utils/config';

export const PTP_URL = `${API_URL}/ptp`;
